//微信语音录制和播放
import wx from "weixin-jsapi";
import Vue from 'vue';
/*
* 需要在jsapi中注册接口权限
* 'startRecord',
  'stopRecord',
  'onVoiceRecordEnd',
  'uploadVoice',
  'downloadVoice',
  'playVoice',
  'translateVoice'
*/
export const wxAudioRecord = {
  // 启动录制
  startRecording(callback1, callback2, timeoutPeriod) {
    let timeout = false;  // 超时
    let timeoutRecording = setTimeout(() => {
      console.log('启动录音超时');
      callback1(false, "stopRecord");
      timeout = true;
    }, timeoutPeriod)

    let that = this;
    wx.startRecord({
      success: function (res) {
        if (res.errMsg == 'startRecord:ok') {
          if(timeout){
            that.cancelRecord(callback1);
          }else{
            clearTimeout(timeoutRecording);
            Vue.prototype.$toast('开始录制');
            callback1(true, "startRecord")
          }
        }
      },
      fail: function (res) {
        callback1(false, "startRecord:fail")
        alert(`启动录制失败${JSON.stringify(res)}`)
      }
    })

    // 录音时间超过一分钟没有停止的时候会执行 complete 回调
    wx.onVoiceRecordEnd({
      complete: function (res) {
        let localId = res.localId;
        callback1(false, "stopRecord")
        that.uploadVoice(localId, callback2);
      }
    });

  },

  // 停止录制
  stopRecording(callback1,callback2) {
    console.log('开始录制');
    let that = this;
    console.log('wx=', wx);
    wx.stopRecord({
      success: function (res) {
        Vue.prototype.$toast('录制成功')
        let localId = res.localId;
        callback1(false, "stopRecord");
        that.uploadVoice(localId, callback2);
        // that.audioTransText(localId, callback2);
      },
      fail: function (res) {
        callback1(false, "stopRecord");
        alert(`录制失败${JSON.stringify(res)}`)
      }
    })
  },

  // 取消录制
  cancelRecord(callback1) {
    wx.stopRecord({
      success: function (res) {
        callback1(false, "stopRecord");
        Vue.prototype.$toast.fail( '录音超时，请重试')
      },
      fail: function (res) {
        callback1(false, "stopRecord");
        alert(`取消失败${JSON.stringify(res)}`)
      }
    })
  },

  // 上传音频
  uploadVoice(localId, callback) {
    let that = this;
    wx.uploadVoice({
      localId: localId, // 需要上传的音频的本地ID，由stopRecord接口获得
      isShowProgressTips: 1, // 默认为1，显示进度提示
      success: function (res) {
        // 返回音频的服务器端ID
        let serverId = res.serverId;
        that.audioTransText(localId, serverId, callback)
      },
      fail: function (res) {
        alert(`语音上传失败${res}`);
      }
    });
  },

  // 语音转文字
  audioTransText(localId, serverId, callback){
    wx.translateVoice({
      localId: localId, // 需要识别的音频的本地Id，由录音相关接口获得
      isShowProgressTips: 1, // 默认为1，显示进度提示
      success: function (res) {
        callback(res.translateResult, serverId); // 语音识别的结果(文字，语音)
      }
    });
  },

  // 播放音频
  playRecord(serverId) {
    wx.downloadVoice({
      serverId: serverId, // 需要下载的音频的服务器端ID，由uploadVoice接口获得
      isShowProgressTips: 1, // 默认为1，显示进度提示
      success: function (res) {
        let localId = res.localId; // 返回音频的本地ID
        wx.playVoice({
          localId: localId, // 需要播放的音频的本地ID，由stopRecord接口获得
          fail: function (res) {
            console.log(`播放语音失${res}`)
          }
        });
      },
      fail: function (res) {
        alert(`下载语音失败${JSON.stringify(res)}serverId=${serverId}`)
      }
    });
  },
}



// WEBPACK FOOTER //
// ./src/util/wxAudioRecord.js